import React from 'react';
import { Select } from './Select';
import type { SelectOption } from '../../types';
import { Box } from '@beeline.com/bp-design-system';
import { selectStyleProps, tableSelectSx } from './styles';

interface Props {
  onChange: (value: SelectOption | null) => void;
  value?: SelectOption;
  options: readonly SelectOption[];
  sort?: boolean;
}

export const TableSelect = ({ onChange, value, options, sort }: Props) => {
  return (
    <Box sx={tableSelectSx}>
      <Select
        value={value}
        onChange={onChange}
        placeholder=" "
        options={options}
        open
        style={selectStyleProps}
        sort={sort}
      />
    </Box>
  );
};
